import {InputAdornment, TextField} from "@mui/material";
import React from "react";
import {useMuseumFilterState} from "./MuseumList/museumFilterContext";
import {FilterAlt} from "@mui/icons-material";

export const MuseumFilterInput = ({museumSearch, setMuseumSearch}) => {
    const {
        filterLabel,
    } = useMuseumFilterState();

    return (
        <TextField
            variant={"outlined"}
            type={"search"}
            placeholder={filterLabel}
            sx={{margin: 2}}
            value={museumSearch}
            onChange={event => setMuseumSearch(event.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position={"start"}>
                        <FilterAlt />
                    </InputAdornment>
                )
            }}
        />
    )
}